import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PriceTag(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PriceTag", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "m35.946 27.459-1.22-.91.033-.033 1.252.882-.065.061Zm.491 6.985-1.42.789-.072-.068 1.42-.8.072.08Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "m42.664 17.035-9.055-5.03a5.992 5.992 0 0 0-2.914-.755H5.25a3 3 0 0 0-3 3v19.5a3 3 0 0 0 3 3h25.445a6 6 0 0 0 2.914-.755l9.055-5.03a6 6 0 0 0 3.086-5.245v-3.44a5.999 5.999 0 0 0-3.086-5.245ZM37.5 27.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M39 24.75c-.557.012-1.11.09-1.65.231a6.104 6.104 0 0 0-2.61 1.554c.171.189.362.359.569.508.208.151.433.28.669.384A4.425 4.425 0 0 1 39 26.25a4.5 4.5 0 1 1 0 9 4.437 4.437 0 0 1-2.58-.818l-1.418.788A6 6 0 1 0 39 24.75Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M27.75 22.5a.75.75 0 0 0 .75-.75V21a3.754 3.754 0 0 0-3.75-3.75v-.75a.75.75 0 1 0-1.5 0v.75a3.75 3.75 0 0 0 0 7.5v4.5A2.25 2.25 0 0 1 21 27v-.75a.75.75 0 1 0-1.5 0V27a3.754 3.754 0 0 0 3.75 3.75v.75a.75.75 0 1 0 1.5 0v-.75a3.75 3.75 0 0 0 0-7.5v-4.5A2.25 2.25 0 0 1 27 21v.75a.75.75 0 0 0 .75.75ZM27 27a2.25 2.25 0 0 1-2.25 2.25v-4.5A2.25 2.25 0 0 1 27 27Zm-3.75-3.75a2.25 2.25 0 0 1 0-4.5v4.5Zm-9-9h-7.5v19.5h7.5v-19.5Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M14.25 13.5h-7.5V15h7.5v-1.5Zm0 3h-7.5V18h7.5v-1.5Zm0 4.5h-7.5v1.5h7.5V21Zm0 4.5h-7.5V27h7.5v-1.5Zm0 3h-7.5V30h7.5v-1.5Zm0 4.5h-7.5v1.5h7.5V33Z"
      }
    )
  ] });
}
PriceTag.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PriceTag"
};
validateTidalLicense();
export {
  PriceTag
};
//# sourceMappingURL=PriceTag.js.map
